import PageInner from './PageInner';

export default PageInner;
